import { render } from "./expertDetail.vue?vue&type=template&id=accb5ef8&scoped=true&ts=true"
import script from "./expertDetail.vue?vue&type=script&lang=ts"
export * from "./expertDetail.vue?vue&type=script&lang=ts"

import "./expertDetail.vue?vue&type=style&index=0&id=accb5ef8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-accb5ef8"]])

export default __exports__